import {OptionWithValues, useProductOptions} from '@shopify/hydrogen';
import ProductOptionsDefault from './ProductOptionsDefault.client';
import ProductOptionsType from './ProductOptionsType.client';

/**
 * A client component that tracks a selected variant and/or selling plan state, as well as callbacks for modifying the state
 */

export default function ProductOptions() {
  const {options} = useProductOptions();

  return (
    <>
      <div className="grid">
        {(options as OptionWithValues[])?.map(({name, values}) => {
          switch (name) {
            case 'Type':
              return (
                <ProductOptionsType key={name} name={name} values={values} />
              );
            default:
              return (
                <ProductOptionsDefault key={name} name={name} values={values} />
              );
          }
        })}
      </div>

      <div className="my-4 w-full" />
    </>
  );
}
